import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentInfo = ({ paymentMethod, billingAddress }) => {
  const getPaymentIcon = (type) => {
    switch (type.toLowerCase()) {
      case 'visa':
        return 'CreditCard';
      case 'mastercard':
        return 'CreditCard';
      case 'paypal':
        return 'Wallet';
      case 'apple pay':
        return 'Smartphone';
      default:
        return 'CreditCard';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
        <Icon name="CreditCard" size={24} className="mr-2 text-primary" />
        Payment Information
      </h2>
      
      <div className="space-y-4">
        {/* Payment Method */}
        <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
          <div className="flex items-center">
            <Icon name={getPaymentIcon(paymentMethod.type)} size={20} className="mr-3 text-primary" />
            <div>
              <p className="font-medium text-foreground">{paymentMethod.type}</p>
              <p className="text-sm text-muted-foreground">
                **** **** **** {paymentMethod.lastFour}
              </p>
            </div>
          </div>
          <div className="flex items-center text-success">
            <Icon name="CheckCircle" size={20} className="mr-1" />
            <span className="text-sm font-medium">Paid</span>
          </div>
        </div>
        
        {/* Billing Address */}
        <div>
          <h3 className="font-medium text-foreground mb-2 flex items-center">
            <Icon name="FileText" size={16} className="mr-2 text-muted-foreground" />
            Billing Address
          </h3>
          <div className="bg-background border border-border rounded-lg p-4">
            <p className="font-medium text-foreground">{billingAddress.name}</p>
            <p className="text-sm text-muted-foreground">{billingAddress.street}</p>
            <p className="text-sm text-muted-foreground">
              {billingAddress.city}, {billingAddress.state} {billingAddress.zipCode}
            </p>
            <p className="text-sm text-muted-foreground">{billingAddress.country}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;